export default "__VITE_ASSET__bc05cc21__"